import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';

@Component({
  selector: 'app-multimedia-archive-preview',
  imports: [ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './multimedia-archive-preview.component.html',
  styleUrl: './multimedia-archive-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaArchivePreviewComponent {
  public readonly alt = input.required<string>();
  public readonly previewUrl = input.required<string>();
  public readonly width = input.required<number>();
  public readonly height = input.required<number>();
}
